import {useInView} from 'react-intersection-observer';

import BenchlingConfig from 'BenchlingConfig';
import {pageLoadID} from 'ClientHeaders';

// Wrapper for useInView, providing a more similar interface and return type to useHasBeenInView;
// see client/ui-library/hooks/useHasBeenInView.ts
export function useIsNowInView(enabled: boolean = true): {
  ref: (node?: Element | null) => void;
  inView?: boolean;
} {
  // Only enable if the browser has support for the IntersectionObserver
  enabled = enabled && typeof IntersectionObserver !== 'undefined';
  const result = useInView({triggerOnce: false, skip: !enabled});
  return {
    ref: result.ref,
    inView: enabled ? result.inView : undefined,
  };
}

export function isRevirtualizationEnabled(uuid: string = pageLoadID): boolean {
  if (!BenchlingConfig.ELN_ENABLE_REVIRTUALIZATION) {
    return false;
  }
  const digits = uuid.split('-')[4];
  const integer = parseInt(digits, 16);
  const value = integer / 0x1000000000000;
  return value < BenchlingConfig.ELN_ENABLE_REVIRTUALIZATION_PROBABILITY;
}
